function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSmiley = function SvgSmiley(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19499"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 18594",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26090",
    d: "M11.121 11.121a3 3 0 0 1-4.243 0M15 9a6 6 0 1 1-6-6 6 6 0 0 1 6 6zM7.5 7.5c0 .276-.112.5-.25.5S7 7.776 7 7.5s.112-.5.25-.5.25.224.25.5zm-.25 0h.005v.01H7.25zm3.75 0c0 .276-.112.5-.25.5s-.25-.224-.25-.5.112-.5.25-.5.25.224.25.5zm-.25 0h.005v.01h-.005z",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }));
};

export default SvgSmiley;